import React from "react"
import ShoppingCartLoader from "./shoppingcartloader"

const ShoppingCartLoaderContainer = () => {
    return(
        <ShoppingCartLoader/>
    )
}

export default ShoppingCartLoaderContainer
